import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import optionsSelectors from '../../store/selectors/optionsSelectors';
import { CustomiseSections } from '../../../common/enum/CustomiseSections';
import usePlatformConfig from '../../../common/react/usePlatformConfig';
import customise from '../../constants/customise';
import stock from '../../../stock/constants/stock';

const useNavigationBarItems = (isStockDetail: boolean) => {
  const availableOptions = useSelector(optionsSelectors.getOptions);
  const {
    platformConfig: { isComplexModel, stockPage },
  } = usePlatformConfig();
  const [navigationItems, setNavigationItems] = useState(
    isStockDetail
      ? stock.DETAILS_VIEW_ITEMS
      : isComplexModel
      ? customise.COMPLEX_NAVIGATION_ITEMS
      : customise.NAVIGATION_ITEMS,
  );

  useEffect(() => {
    let filteredNavigationItems = [...navigationItems];

    if (stockPage && !navigationItems.includes(customise.STOCK_ITEM)) {
      filteredNavigationItems = [...filteredNavigationItems, customise.STOCK_ITEM];
    }

    if (availableOptions && !availableOptions.servicePlans.count) {
      const optionItem = navigationItems.find(item => item.name === CustomiseSections.SERVICE_PLAN);
      filteredNavigationItems = filteredNavigationItems.filter(item => item !== optionItem);
    }
    if (availableOptions && !availableOptions.accessories.count) {
      const optionItem = navigationItems.find(item => item.name === CustomiseSections.ACCESSORIES);
      filteredNavigationItems = filteredNavigationItems.filter(item => item !== optionItem);
    }
    // Please note that Options are considered Accessories packs - Might be different from other markets
    // But currently this is enough for the available markets
    if (availableOptions && !availableOptions.accessoryPacks.count) {
      const optionItem = navigationItems.find(item => item.name === CustomiseSections.PACKS);
      filteredNavigationItems = filteredNavigationItems.filter(item => item !== optionItem);
    }

    setNavigationItems(filteredNavigationItems);
  }, [availableOptions]);

  return { navigationItems };
};

export default useNavigationBarItems;
